import { useState } from 'react'
import { IoMdCheckmark } from 'react-icons/io'
import { useParams } from 'react-router'

export default function SingleSelectResponseQuestion({ question, setAnswer }) {
  const { lng } = useParams()
  const [selectedResponse, setSelectedResponse] = useState(null) // Only one response is allowed

  // Handle checkbox change
  function handleChange(question_id, response_id) {
    setSelectedResponse({
      question_id,
      response_id: response_id,
    })

    setAnswer((prev) => {
      const updatedResponses = prev.responses.map((response) => {
        if (response.question_id === question_id) {
          // Update the existing response
          return {
            question_id: response.question_id,
            response_id: response_id,
          }
        }
        return response // Return other responses unchanged
      })

      // If the question_id doesn't exist, add a new response
      if (!updatedResponses.some((response) => response.question_id === question_id)) {
        updatedResponses.push({ question_id, response_id })
      }

      return {
        ...prev,
        responses: updatedResponses,
      }
    })
  }

  return (
    <div
      key={question.id}
      data-aos={`fade-up`}
      data-aos-delay={100}
      className="flex flex-col border-2 border-muted-300"
    >
      <h4 className="border-b-2 border-muted-300 bg-muted-100 px-4 py-3 font-bold">{question[`text_${lng}`]}</h4>
      <div className="flex flex-col gap-1 p-4">
        {question.responses?.map((response) => (
          <div
            key={response.id}
            className="flex items-center gap-4"
          >
            <input
              type="radio"
              id={`${question.type}-${question.id}-${response.id}`}
              name={`question-${question.id}`}
              className="peer hidden"
              onChange={(e) => handleChange(question.id, response.id, e.target.checked)}
              checked={selectedResponse && selectedResponse?.response_id === response.id}
            />
            <label
              htmlFor={`${question.type}-${question.id}-${response.id}`}
              className="flex h-4 w-4 items-center justify-center border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"
            >
              <IoMdCheckmark
                size={16}
                strokeWidth={1.2}
              />
            </label>
            <label htmlFor={`${question.type}-${question.id}-${response.id}`}>{response[`text_${lng}`]}</label>
          </div>
        ))}
      </div>
    </div>
  )
}
